import React from 'react';
import AppSplash from '../AppSplash/AppSplash';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * TeacherProtectedRoute — wraps teacher-only routes.
 * Redirects unauthenticated users to /teacher-login.
 * Redirects authenticated non-teachers to their appropriate home.
 */
function TeacherProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <AppSplash />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/teacher-login" replace />;
  }

  if (user?.role !== 'TEACHER') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default TeacherProtectedRoute;
